import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { createJourneyType } from "../../../../graphql/mutations";
import SimpleCreateEdit from "../../../Common/Crud/SimpleCreateEdit";
import TextInput from "../../../../components/Common/TextInput";
import * as JourneyTypesConstants from "../../../../graphql/Constants/JourneyTypes/Types";
import nameChangeHandler from "../../../Common/Crud/formHandlers/nameChangeHandler";
import orderChangeHandler from "../../../Common/Crud/formHandlers/orderChangeHandler";
import nameOnlyFormsValidationHandler from "../../../Common/Crud/formHandlers/nameOnlyFormsValidationHandler";
import * as CrudActionTypes from "../../../../constants/Crud/ActionTypes";
import * as ModelTypes from "../../../../graphql/Constants/ModelTypes";

const JourneyTypeCreate = (props) => {
  // states
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [inputFieldsDisable, setInputFieldsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [createButtonDisableStatus, setCreateButtonDisableStatus] = useState(
    false
  );

  const handleCreateJourneyType = async () => {
    try {
      const input = {
        type: ModelTypes.JourneyType,
        name: name.trim(),
        order: order,
        deletedAt: null,
      };
      await API.graphql(graphqlOperation(createJourneyType, { input }));
      return { result: true, message: `JourneyType created successfully` };
    } catch (error) {
      return { result: false, message: `Error creating JourneyType, ${error}` };
    }
  };

  return (
    <SimpleCreateEdit
      {...props}
      crudActionType={CrudActionTypes.Create}
      returnHandler={() => props.history.push(`/journeyTypes`)}
      modelName="JourneyType"
      // createOrUpdateDisableMethod={(modelData) => {
      //   if (modelData.id === SkillsConstants.Other.id) return true;
      //   return false;
      // }}
      // createOrUpdateDisabledActions={() => {
      //   setNameInputTextDisable(true);
      // }}
      formSubmissionHandler={handleCreateJourneyType}
      formValidationHandler={() =>
        nameOnlyFormsValidationHandler(
          name,
          "JourneyType",
          false, // we need to exclude the OTHER,
          setCreateButtonDisableStatus,
          setErrors
        )
      }
      setErrorsState={() => setErrors}
      actionButtonDisabledState={createButtonDisableStatus}
    >
      <TextInput
        type="name"
        id="name"
        label="JourneyType Name"
        placeholder="Enter a JourneyType name"
        value={name}
        onChange={(e) =>
          nameChangeHandler(
            e,
            "JourneyType",
            false, // we need to exclude the OTHER,
            setName,
            setCreateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.name}
        disabled={inputFieldsDisable}
      />
      <TextInput
        type="number"
        id="order"
        label="JourneyType Order"
        placeholder="Enter a JourneyType Order"
        value={order}
        onChange={(e) =>
          orderChangeHandler(
            e,
            "JourneyType",
            setOrder,
            setCreateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.order}
        disabled={inputFieldsDisable}
      />
    </SimpleCreateEdit>
  );
};

export default JourneyTypeCreate;
